module.exports = __webpack_public_path__ + "img/img11.247dccd8.png";